import React, { Component } from 'react'
import { connect } from 'react-redux'
import StartSuccessPage from './Start/StartSuccessPage'
import StartErrorPage from './Start/StartErrorPage'
import StartWithLogin from './Start/StartWithLogin'
import * as actions from '../store/actions'
import StartPageStyle from '../styles/StartPageStyle'
import Progress from './controls/Progress'

export class StartPage extends Component {
  state = { urlToken: false, path: '' }

  isURLToken() {
    let token = window.location.search
    if (token.includes('?token=')) {
      token = token.split('?token=')
      return token.length === 2
    }
    return false
  }

  getURLPath() {
    let path = window.location.search
    if (path.includes('?path=')) {
      path = path.split('?path=')
      if (path.length === 2) return path[1]
    }
    return ''
  }

  componentWillMount() {
    const token = this.isURLToken()
    if (token) {
      this.setState({ urlToken: true })
      if (!this.props.licencja) this.props.onGetLicence()
    } else {
      const urlPath = this.getURLPath()
      if (urlPath === 'login' || urlPath === 'account')
        this.setState({ path: urlPath })
    }
  }

  render() {
    const {
      licencja,
      availableStructures,
      wyborStruktury,
      onUpload,
      onSetCzyWyborDaty,
      onCloseErrorDialog,
      error,
    } = this.props
    return (
      <StartPageStyle licencja={licencja}>
        {licencja &&
          (licencja.status === '0' || licencja.system === 'ESPR') && (
            <StartSuccessPage
              licencja={licencja}
              availableStructures={availableStructures}
              wyborStruktury={wyborStruktury}
              onSetCzyWyborDaty={() => onSetCzyWyborDaty(true)}
              onUpload={onUpload}
              onCloseErrorDialog={onCloseErrorDialog}
            />
          )}
        {this.state.urlToken && !licencja && !error && (
          <Progress isOpen={true} progressText="Trwa weryfikacja licencji..." />
        )}
        {!this.state.urlToken && !licencja && (
          <StartWithLogin path={this.state.path} />
        )}
        {((error && this.state.urlToken) ||
          (licencja &&
            licencja.system !== 'ESPR' &&
            licencja.status !== '0')) && <StartErrorPage />}
      </StartPageStyle>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGetLicence: () => dispatch(actions.getLicence()),
    onUpload: e => dispatch(actions.uploadFile(e)),
    onCloseErrorDialog: () => dispatch(actions.clearError()),
    onSetCzyWyborDaty: x => dispatch(actions.setCzyWyborDaty(x)),
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(StartPage)
